import React, { FC, useEffect } from 'react';

import ScrollToTop from '@components/shared/ScrollToTop/ScrollToTop';

import { Spin, Typography } from 'antd';

import PlansTable from '../AllPlans/components/PlansTable/PlansTable';

import { useLazyGetProducerPlansQuery } from '@store/coverage';
import { useParams } from 'react-router-dom';

const { Title } = Typography;

const ProducerPlans: FC = () => {
  const { npn } = useParams<{ npn: string }>();
  const [triggerGetProducerPlans, { data, isLoading }] =
    useLazyGetProducerPlansQuery();

  useEffect(() => {
    if (npn) {
      triggerGetProducerPlans(npn);
    }
  }, [npn, triggerGetProducerPlans]);

  return (
    <div>
      <ScrollToTop />
      <Title
        level={1}
        className="text-center my-5 py-5 font-bold text-2xl bg-[#59DFE533]"
      >
        Plans by Producer NPN: {npn} for Affiliate
      </Title>
      {isLoading ? (
        <Spin size="large" className="flex justify-center" />
      ) : (
        <PlansTable tableData={data || []} />
      )}
    </div>
  );
};

export default ProducerPlans;
